"use strict";

const mobileContainer = [];

// Loop over gallery items and push them to the array
document.querySelectorAll(".embla__slide").forEach((figure) => {
  const link = figure.querySelector("a");
  const item = {
    src: link.getAttribute("href"),
    w: parseInt(link.dataset.width, 10),
    h: parseInt(link.dataset.height, 10),
    title: link.dataset.caption,
  };
  mobileContainer.push(item);
});

document.querySelectorAll(".embla__slide a").forEach((anchor) => {
  anchor.addEventListener("click", (event) => {
    event.preventDefault();

    const pswpElement = document.querySelector(".pswp");

    const options = {
      index: Array.from(anchor.parentElement.parentElement.children).indexOf(
        anchor.parentElement
      ),
      showHideOpacity: true,
      showAnimationDuration: 500,
      loop: false,
      history: false,
      closeOnVerticalDrag: false,
      allowPanToNext: false,
      pinchToClose: false,
      initialZoomLevel: 'fill',
      // scaleMode: 'zoom',
      getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
        if (isMouseClick) {
          return 1.6;
        } else {
          return item.initialZoomLevel < 0.7 ? 1 : 1.33;
        }
      },
    };

    // Initialize PhotoSwipe
    const gallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI_Default,
      mobileContainer,
      options
    );
    gallery.init();
  });
});

// FOR DESKTOP
const desktopcontainer = [];

document.querySelectorAll(".Product__SlideItem").forEach((figure) => {
  const link = figure.querySelector("a");
  const item = {
    src: link.getAttribute("href"),
    w: parseInt(link.dataset.width, 10),
    h: parseInt(link.dataset.height, 10),
    title: link.dataset.caption,
  };
  desktopcontainer.push(item);
});

// Define click event on gallery items
document.querySelectorAll(".Product__SlideItem a").forEach((anchor) => {
  anchor.addEventListener("click", (event) => {
    event.preventDefault();

    // Get the PhotoSwipe element
    const pswpElement = document.querySelector(".desktop_pswp");

    // Define gallery options
    const options = {
      index: Array.from(anchor.parentElement.parentElement.children).indexOf(
        anchor.parentElement
      ),
      showHideOpacity: true,
      showAnimationDuration: 500,
      loop: true,
      history: false,
      closeOnVerticalDrag: false,
      allowPanToNext: false,
      pinchToClose: false,
      initialZoomLevel: "fill",
      // scaleMode: 'zoom',
      getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
        if (isMouseClick) {
          return 1.6;
        } else {
          return item.initialZoomLevel < 0.7 ? 1 : 1.33;
        }
      }
    };
    // Initialize PhotoSwipe
    const desktopGallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI_Default,
      desktopcontainer,
      options
    );
    desktopGallery.init();
  });
});

